export const CONTACT_US_MODAL = 'CONTACT_US_MODAL'
export const SUPERUSER_SELECTOR_MODAL = 'SUPERUSER_SELECTOR_MODAL'
export const PARTNER_SELECTOR_MODAL = 'PARTNER_SELECTOR_MODAL'
export const GRID_TICKET_MODAL = 'GRID_TICKET_MODAL'
export const GRID_DATES_MODAL = 'GRID_DATES_MODAL'
export const PROMO_CODE_MODAL = 'PROMO_CODE_MODAL'
export const VOUCHER_EDIT_MODAL = 'VOUCHER_EDIT_MODAL'



/** WEBPACK FOOTER **
 ** ./src/constants/modal-constants.js
 **/